import ic_checkmark_vec from "../images/ic_checkmark_vec.png";
import ic_calendar_vec from "../images/ic_calendar_vec.png";
import ic_cross_vec from "../images/ic_cross_vec.png";
import ic_hourglass_vec from "../images/ic_hourglass_vec.png";

export const formatNotificationTime = (createdDate) => {
  const now = new Date();
  const notificationDate = new Date(createdDate);
  const diffInSeconds = Math.floor((now - notificationDate) / 1000);
  
  if (diffInSeconds < 60) {
    return `${diffInSeconds}s ago`;
  }
  
  const diffInMinutes = Math.floor(diffInSeconds / 60);
  if (diffInMinutes < 60) {
    return `${diffInMinutes}m ago`;
  }
  
  const diffInHours = Math.floor(diffInMinutes / 60);
  if (diffInHours < 24) {
    return `${diffInHours}h ago`;
  }
  
  const diffInDays = Math.floor(diffInHours / 24);
  if (diffInDays < 7) {
    return `${diffInDays}d ago`;
  }
  
  const diffInWeeks = Math.floor(diffInDays / 7);
  if (diffInWeeks < 4) {
    return `${diffInWeeks}w ago`;
  }
  
  const diffInMonths = Math.floor(diffInDays / 30);
  if (diffInMonths < 12) {
    return `${diffInMonths}mo ago`;
  }
  
  const diffInYears = Math.floor(diffInMonths / 12);
  return `${diffInYears}y ago`;
};

export const getNotificationIcon = (notificationType) => {
  const iconBasePath = process.env.PUBLIC_URL || '';
  
  switch (notificationType) {
    case 'SlotBooking':
      return ic_checkmark_vec;
    case 'SlotRescheduled':
      return ic_calendar_vec;
    case 'SlotCancelled':
      return ic_cross_vec;
    default:
      return ic_hourglass_vec;
  }
};

export const getNotificationRedirectUrl = (notification, role) => {
  const { notificationType, bookingId } = notification;
  
  if (!bookingId) return null;
  
  // Common session details page path
  const sessionDetailsPath = `/sessions/sessionDetails/${bookingId}`;
  
  // You can customize based on notification type or role if needed
  switch (notificationType) {
    case 'SlotBooking':
    case 'SlotRescheduled':
    case 'SlotCancelled':
    case 'SessionReminder':
      return sessionDetailsPath;
    default:
      return sessionDetailsPath;
  }
};